/* [RR perf] Wartet auf die Swiper-Bibliothek.

   Swiper laedt jetzt mit async und kann deshalb nach den Slider-Skripten ankommen. Vorher
   stiegen die Skripte in diesem Fall einfach aus und der Slider blieb still stehen. Mit
   bdWhenSwiper melden sie sich an und werden aufgerufen, sobald die Bibliothek da ist.

   window.bdWhenSwiper(rueckruf) ruft sofort auf, wenn Swiper schon bereitsteht, sonst
   spaeter. Kommt die Bibliothek gar nicht, wird der Rueckruf nie aufgerufen; jedes Skript
   bleibt selbst dafuer zustaendig, ohne Swiper etwas Sinnvolles anzuzeigen. */
(function () {
  if (window.bdWhenSwiper) return;

  var warteschlange = [];
  var pruefung = null;
  var versuche = 0;

  function bereit() {
    return typeof window.Swiper !== 'undefined';
  }

  function abarbeiten() {
    if (pruefung) {
      clearInterval(pruefung);
      pruefung = null;
    }
    var offen = warteschlange;
    warteschlange = [];
    offen.forEach(function (rueckruf) {
      try {
        rueckruf();
      } catch (fehler) {
        console.error('[RR] Slider konnte nicht starten', fehler);
      }
    });
  }

  function beobachten() {
    if (pruefung) return;
    pruefung = setInterval(function () {
      versuche += 1;
      if (bereit()) {
        abarbeiten();
        return;
      }
      /* Nach zehn Sekunden ist die Bibliothek nicht mehr zu erwarten. */
      if (versuche > 200) {
        clearInterval(pruefung);
        pruefung = null;
        warteschlange = [];
        console.warn('[RR] Swiper wurde nicht geladen, Slider laufen im Rueckfall');
      }
    }, 50);
  }

  window.bdWhenSwiper = function (rueckruf) {
    if (typeof rueckruf !== 'function') return;
    if (bereit()) {
      rueckruf();
      return;
    }
    warteschlange.push(rueckruf);
    beobachten();
  };
})();
